/* eslint-disable import/prefer-default-export */
export const isMobile = () =>
  (navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|IEMobile)/));

export const isIE = () => /MSIE \d|Trident.*rv:/.test(navigator.userAgent);



// WEBPACK FOOTER //
// ./book/src/commons/utils/browser-utils.js